import React from 'react';

import { useFeatureServices } from './use-feature-services';

import _ from 'lodash';
import { FeatureAppTrackingEvent, FeatureAppTrackingManager, TrackingEvent } from '../typings/tagging';

const defaultTrackingEvent: FeatureAppTrackingEvent = {
  eventInfo: {
    pageName: 'Maintenance',
    pageCategory: 'Maintenance',
    brand: 'passenger',
  },

  environment: {
    featureAppIdAppVersion: process.env.APPVERSION,
    featureAppId: 'Digital-Owners-Literature-D6-US',
  },
};

export function getDefaultTrackingEvent() {
  return _.cloneDeep(defaultTrackingEvent);
}

function buildTrackingEvent(
  cusTrackEvent?: FeatureAppTrackingEvent,
): FeatureAppTrackingEvent {
  let trackingEvent: FeatureAppTrackingEvent;

  if (cusTrackEvent) {
    trackingEvent = _.cloneDeep(cusTrackEvent);
  } else {
    trackingEvent = _.cloneDeep(defaultTrackingEvent);
  }

  if (!trackingEvent.eventInfo) {
    trackingEvent.eventInfo = {};
  }
  trackingEvent.eventInfo.brand = 'passenger';

  return trackingEvent;
}

export function getTrackEventClone(): FeatureAppTrackingEvent {
 const clonedEvent = _.cloneDeep(defaultTrackingEvent);
  clonedEvent.eventInfo = {
    ...clonedEvent.eventInfo,
    brand: 'passenger'
  };
  return clonedEvent;
}

export function useTrackingManager(): FeatureAppTrackingManager {
  const trackingManager = useFeatureServices()['tracking']!;

  return React.useMemo((): FeatureAppTrackingManager => {
    function track(action: string, event: FeatureAppTrackingEvent): void {
      if (trackingManager) {
        trackingManager.track(action, event as unknown as TrackingEvent);
      }
    }
    return {
      trackMaintenanceGlobalEvent(
        event: string,
        trackEvent?: FeatureAppTrackingEvent,
      ): void {
        track(event, buildTrackingEvent(trackEvent));
      },
    };
  }, [trackingManager]);
}
